/**
 * Branded checkout host: https://checkout.noorqalb.co.uk  (no /checkout path)
 */
(function () {
  var HOST = 'https://checkout.noorqalb.co.uk';
  var FALLBACK = 'https://noorqalb-whop-checkout.halcyon-lighters.workers.dev';

  function isShopifyCheckoutUrl(href) {
    if (!href) return false;
    try {
      var u = new URL(href, location.origin);
      if (u.origin !== location.origin) {
        return /checkout\.shopify\.com|\/checkouts\//i.test(href);
      }
      var p = u.pathname.replace(/\/$/, '') || '/';
      return p === '/checkout' || /^\/checkouts(\/|$)/.test(p) || p === '/pages/checkout';
    } catch (e) {
      return /\/checkout(\/|$|\?)/i.test(href);
    }
  }

  function imageUrl(item) {
    var img =
      (item.featured_image && (item.featured_image.url || item.featured_image.src)) ||
      item.image ||
      '';
    if (!img) return '';
    if (img.indexOf('//') === 0) return 'https:' + img;
    if (img.indexOf('/') === 0) return location.origin + img;
    return img;
  }

  /** Keep only fields checkout needs — accurate lines + images, small enough for URL */
  function slimCart(cart) {
    return {
      token: cart.token || '',
      item_count: cart.item_count || 0,
      total_price: cart.total_price || 0,
      items_subtotal_price: cart.items_subtotal_price || cart.total_price || 0,
      currency: cart.currency || 'USD',
      items: (cart.items || []).map(function (item) {
        var variant =
          item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        return {
          product_title: item.product_title || item.title || 'Item',
          variant_title: variant,
          title: item.title || item.product_title || 'Item',
          quantity: Number(item.quantity) || 1,
          final_line_price: Number(item.final_line_price != null ? item.final_line_price : item.line_price) || 0,
          line_price: Number(item.line_price) || 0,
          original_line_price: Number(item.original_line_price) || 0,
          price: Number(item.price) || 0,
          sku: item.sku || '',
          variant_id: item.variant_id || '',
          product_id: item.product_id || '',
          handle: item.handle || '',
          image: imageUrl(item),
          url: item.url || '',
        };
      }),
    };
  }

  function encodeCart(cart) {
    return btoa(unescape(encodeURIComponent(JSON.stringify(slimCart(cart)))));
  }

  async function pickHost() {
    try {
      var c2 = new AbortController();
      var t2 = setTimeout(function () {
        c2.abort();
      }, 900);
      var r2 = await fetch(HOST + '/health', { signal: c2.signal, mode: 'cors', cache: 'no-store' });
      clearTimeout(t2);
      if (r2.ok) return HOST;
    } catch (e2) {}
    return FALLBACK;
  }

  async function goWhop(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }
    var host = await pickHost();
    try {
      var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
        return r.json();
      });
      if (!cart || !cart.item_count) {
        window.location.assign('/cart');
        return false;
      }
      // Root of checkout host — no /checkout in the URL
      window.location.assign(host + '/?cart=' + encodeURIComponent(encodeCart(cart)));
    } catch (err) {
      window.location.assign(host + '/');
    }
    return false;
  }

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest('a');
      if (a) {
        var href = a.getAttribute('href') || '';
        if (
          a.hasAttribute('data-nq-whop-checkout') ||
          a.classList.contains('checkout-btn') ||
          isShopifyCheckoutUrl(href)
        ) {
          return goWhop(e);
        }
      }
      var btn = e.target.closest('button[name="checkout"], input[name="checkout"]');
      if (btn) return goWhop(e);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (
        form.querySelector('[name="checkout"]') ||
        (form.getAttribute('action') && isShopifyCheckoutUrl(form.getAttribute('action')))
      ) {
        return goWhop(e);
      }
    },
    true
  );
})();
